import { css } from '@emotion/react';
import { Paragraph, Spinner } from '../atoms';
import { rem } from '../pixels';
import { colors } from '..';

const loadingContainerStyles = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  minHeight: 400,
  gap: rem(12),
});

const Loading: React.FC<Record<string, never>> = () => (
  <div css={[loadingContainerStyles]}>
    <Spinner
      size={18}
      color={colors.neutral900.rgb}
      trackColor={colors.neutral300.rgb}
    />
    <Paragraph noMargin>Loading...</Paragraph>
  </div>
);

export default Loading;
